import { p as proxyCustomElement, H, c as createEvent, h, d as Host } from './p-ae815584.js';
import { b as bem } from './p-c44c2366.js';
import { A as ACTIVATE_KEYS } from './p-5e5972c7.js';
import { d as defineCustomElement$2 } from './p-db87170c.js';
import { r as resolveAppearance } from './p-c01ca34a.js';

const cosmosActionMenuItemCss = ":host{display:block;max-width:100%;position:relative;width:100%}:host(:focus){outline:none}:host(:focus)::before{content:\"\";border-radius:calc(2.66px * 1.5);bottom:calc((4px + -4px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + -4px) * -1);position:absolute;right:calc((4px + -4px) * -1);top:calc((4px + -4px) * -1)}.cosmos-action-menu-item{-ms-flex-align:center;align-items:center;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:default;display:-ms-flexbox;display:flex;gap:6px;-ms-flex-pack:justify;justify-content:space-between;margin:0;max-width:100%;padding:6px 8px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;--cosmos-text-color:var(--cosmos-action-menu-item-color);--cosmos-text-font-family:var(--cosmos-action-menu-item-font-family);--cosmos-text-font-size:var(--cosmos-action-menu-item-font-size);--cosmos-text-font-style:var(--cosmos-action-menu-item-font-style);--cosmos-text-font-weight:var(--cosmos-action-menu-item-font-weight);--cosmos-text-letter-spacing:var(--cosmos-action-menu-item-letter-spacing);--cosmos-text-line-height:var(--cosmos-action-menu-item-line-height);--cosmos-text-text-transform:var(--cosmos-action-menu-item-text-transform)}.cosmos-action-menu-item__side{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex:4;flex:4;gap:var(--cosmos-action-menu-item-gap, 6px);max-width:-moz-fit-content;max-width:-webkit-fit-content;max-width:fit-content;min-width:0}.cosmos-action-menu-item__side--meta{-ms-flex:1;flex:1}.cosmos-action-menu-item__meta{--cosmos-text-font-family:var(--cosmos-action-menu-item-meta-font-family);--cosmos-text-font-size:var(--cosmos-action-menu-item-meta-font-size);--cosmos-text-font-style:var(--cosmos-action-menu-item-meta-font-style);--cosmos-text-font-weight:var(--cosmos-action-menu-item-meta-font-weight)}.cosmos-action-menu-item:hover{background:rgba(0, 15, 30, 0.05)}.cosmos-action-menu-item--active{background:rgba(0, 15, 30, 0.05)}.cosmos-action-menu-item--active:hover{background:rgba(0, 15, 30, 0.1)}.cosmos-action-menu-item--appearance-light{--cosmos-icon-color:#FFFFFF}.cosmos-action-menu-item--appearance-light .cosmos-action-menu-item--active{background:rgba(255, 255, 255, 0.1)}.cosmos-action-menu-item--appearance-light:hover{background:rgba(255, 255, 255, 0.1)}.cosmos-action-menu-item ::slotted([slot=prefix]){-ms-flex:0 0 auto;flex:0 0 auto;--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px}";
const CosmosActionMenuItemStyle0 = cosmosActionMenuItemCss;

const CosmosActionMenuItem$1 = /*@__PURE__*/ proxyCustomElement(class CosmosActionMenuItem extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.actionClick = createEvent(this, "actionClick", 7);
        this.generateClassNames = bem('cosmos-action-menu-item');
        this.active = false;
        this.appearance = undefined;
        this.href = undefined;
        this.itemId = undefined;
        this.meta = '';
        this.rel = undefined;
        this.target = undefined;
        this.computedAppearance = undefined;
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
    }
    handleClick() {
        this.actionClick.emit({ itemId: this.itemId });
    }
    handleKeyDown(event) {
        if (ACTIVATE_KEYS.includes(event.key)) {
            this.actionClick.emit({ itemId: this.itemId });
        }
    }
    composeTitle() {
        var _a;
        const label = (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim();
        if (this.meta) {
            return `${label} • ${this.meta}`;
        }
        return label;
    }
    componentDidLoad() {
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
    }
    render() {
        var _a;
        const Tag = this.href ? 'a' : 'div';
        return (h(Host, { key: '8808f98da5c094905410e6f3aa621c5508cda72e', role: "menuitem", id: this.itemId, "aria-label": (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim() }, h(Tag, { key: 'd41e7bc2662606087b9963bce725fa323279d55a', class: this.generateClassNames({
                appearance: this.computedAppearance,
                active: this.active,
            }), href: this.href, rel: this.rel, target: this.target, part: "base", tabindex: -1 }, h("div", { key: 'a5072e9bc0cefaf1cada79a849adbedeb702028a', class: this.generateClassNames('side'), title: this.composeTitle() }, h("slot", { key: '3de65b742caa1e6a0165ebf751abe5f357674f41', "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { key: 'f5fa464ff82da23e1734a592cd59577e052fa4ac', appearance: this.appearance, exportparts: "base: label", class: this.generateClassNames('label'), size: "small", clamp: 1 }, h("span", { key: 'de1ba7d363ae145f904f7d66bae7e3341f9df6a0' }, h("slot", { key: '2d759b4ac1ed937a8baa1250cd74bd48a214e1f0' })))), h("div", { key: 'f79b4db0c70cc3c4a393817879cd0aee06db9d3a', class: this.generateClassNames('side', {
                meta: !!this.meta,
            }) }, this.meta && (h("cosmos-text", { key: '435c29bbea0ecaf6b377dfa6ca4c2f6155069ac8', appearance: this.appearance, class: this.generateClassNames('meta'), clamp: 1, size: "x-small", kind: "subtle" }, h("span", { key: 'cf1c407562d655fb135ce465244e655003da5962' }, this.meta)))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"]
    }; }
    static get style() { return CosmosActionMenuItemStyle0; }
}, [1, "cosmos-action-menu-item", {
        "active": [516],
        "appearance": [513],
        "href": [513],
        "itemId": [513, "item-id"],
        "meta": [513],
        "rel": [513],
        "target": [513],
        "computedAppearance": [32]
    }, [[0, "click", "handleClick"], [0, "keydown", "handleKeyDown"]], {
        "appearance": ["handleAppearanceChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-action-menu-item", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-action-menu-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosActionMenuItem$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosActionMenuItem = CosmosActionMenuItem$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosActionMenuItem, defineCustomElement };
